export default __webpack_public_path__ + "static/media/fin-s_icon.552bd94d.png";